import React from 'react';
import { format } from 'redux-form-validators';

import { PHONENUMBER_REGEX } from './constants';

import InputFieldComponent from './InputFieldComponent';

class PhoneInputFieldComponent extends React.Component {
    validateMandatory = () => [
        format({
            with: PHONENUMBER_REGEX,
            msg: this.props.i18nFeatureForm.PHONENUMBER_INVALID,
            allowBlank: !this.props.isRequired
        })
    ];

    render() {
        const { validate = [] } = this.props;
        return (
            <InputFieldComponent
                validate={[...this.validateMandatory(), ...validate]}
                type="tel"
                {...this.props}
            />
        );
    }
}

// See proptypes in ./InputFieldComponent.js

export default PhoneInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/PhoneInputFieldComponent.js